import { useQueryClient } from '@tanstack/react-query'
import { ApiResponse } from '../../../types/api'
import { UsersInsertData } from '../../../types/users'
import { useApiPostMutation } from '../useApi'

export const useUsersInsert = () => {
  const queryClient = useQueryClient()

  const mutation = useApiPostMutation<ApiResponse, UsersInsertData>()

  return {
    ...mutation,
    mutate: (data: UsersInsertData, options?: any) => {
      mutation.mutate(
        {
          url: '/users/insert',
          data,
        },
        {
          onSuccess: (result) => {
            queryClient.invalidateQueries({ queryKey: ['usersList'] })
            options?.onSuccess?.(result)
          },
          onError: (error) => {
            options?.onError?.(error)
          },
        }
      )
    },
  }
}
